export const buttons = [
	{ id: 1, title: "خصائص النظام", link: "main" },
	{ id: 2, title: "السوشيال ميديا", link: "socials" },
];
